/* eslint-disable react/prop-types */
import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Per-day pause-session trend split by type (026 US2), on the shared au-panel
 * design system (matches ActiveUsersTrendChart). Meditation = coral, Breathing =
 * teal/sage. Text-labelled legend, point tooltip, graceful single-day/empty.
 *
 * Props: { data } — [{ date:'YYYY-MM-DD', meditation:int, breathing:int }] ascending
 */
const shortDate = (d) => (d ? String(d).split('-').slice(1).reverse().join('/') : '');

const PauseTrendChart = ({ data = [] }) => {
  const enough = Array.isArray(data) && data.length >= 2;

  return (
    <div className="au-panel" data-testid="pause-trend">
      <div className="au-panel__head">
        <h4 className="au-panel__title">Pauses per day · by type</h4>
        <span className="au-spacer" />
        <div className="au-legend">
          <span><i style={{ background: '#f26b45' }} />Meditation</span>
          <span><i style={{ background: '#2e9b87' }} />Breathing</span>
        </div>
      </div>

      {enough ? (
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
            <CartesianGrid stroke="#eef2f1" vertical={false} />
            <XAxis dataKey="date" tickFormatter={shortDate} tick={{ fontSize: 11, fill: '#94a3b8' }} />
            <YAxis width={44} tick={{ fontSize: 11, fill: '#94a3b8' }} allowDecimals={false} />
            <Tooltip
              formatter={(value, name) => [Number(value).toLocaleString(), name]}
              labelFormatter={(l) => `Date: ${String(l).split('-').reverse().join('/')}`}
            />
            <Line type="monotone" dataKey="meditation" name="Meditation" stroke="#f26b45" strokeWidth={2.5} dot={false} />
            <Line type="monotone" dataKey="breathing" name="Breathing" stroke="#2e9b87" strokeWidth={2.5} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="au-chart-empty" data-testid="pause-trend-empty">
          Not enough data to plot a trend (need at least 2 days).
        </div>
      )}
    </div>
  );
};

export default PauseTrendChart;
